<template>
    <v-row justify="center">
        <v-col v-if="! members" cols="12" sm="10" md="8" lg="6">
            <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
        </v-col>

        <v-col v-else cols="12" sm="10" md="8" lg="6">
            <v-list three-line>
                <v-list-item
                    v-for="(member, i) in members"
                    :key="i"
                >
                    <v-list-item-avatar color="avatar">
                        <v-icon color="white">mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ member.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ member.university }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                            ID Line / WA: {{ member.contact }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            members: null
        }
    },

    created() {
        this.$api.get('group/member')
            .then(response => {
                this.members = response.data.members
            })
    }
}
</script>
